import config from "appConfig";
import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "e1e854d2-daa5-4d65-9e94-100c31b35b7f",
    content: "Answer 1",
    options: {
      image: `${config.ASSETS_URL}/04/06/task/task-1-item-1.svg`,
    },
  },
  {
    id: "6728cc0d-d5fa-45d1-9300-1768b8ab1891",
    content: "Answer 2",
    options: {
      image: `${config.ASSETS_URL}/04/06/task/task-1-item-2.svg`,
    },
  },
  {
    id: "3efeba86-2eff-44cd-bf05-db02a483f524",
    content: "Answer 3",
    options: {
      image: `${config.ASSETS_URL}/04/06/task/task-1-item-3.svg`,
    },
  },
  {
    id: "300b4b62-1589-4935-9f05-37420e49aa9b",
    content: "Answer 4",
    options: {
      image: `${config.ASSETS_URL}/04/06/task/task-1-item-4.svg`,
    },
  },
];

export const task: Task = {
  id: "e624e3a0-3ec2-4026-ade0-3a9882b17ff0",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["e1e854d2-daa5-4d65-9e94-100c31b35b7f"],
};
